module.exports = __webpack_public_path__ + "static/media/milk_header.ba208093.png";